import React from 'react';
import {Map} from 'immutable';
import League from './League.jsx';

import {sportSortFunc, leagueSortFunc} from 'rendering-commons/Sorting';

import * as SortMode from '../SortMode';

function matchByStartDateCompare(a, b) {
    const firstStart = a.get('startDate');
    const secondStart = b.get('startDate');

    if (firstStart > secondStart) {
        return 1;
    } else if (firstStart < secondStart) {
        return -1;
    }

    return 0;
}

function sortByTime(matches) {
    let result = matches.slice();

    result.sort(matchByStartDateCompare);

    return result;
}

function sortByLeague(matches, sports, leagues) {
    let result = matches.slice();

    result.sort((a, b) => {
        const firstSport = sports.get(a.get('sportId'));
        const secondSport = sports.get(b.get('sportId'));

        const sportOrder = sportSortFunc(firstSport, secondSport);

        if (sportOrder !== 0) {
            return sportOrder;
        }

        const firstLeague = leagues.get(a.get('leagueId'));
        const secondLeague = leagues.get(b.get('leagueId'));

        const leagueOrder = leagueSortFunc(firstLeague, secondLeague);

        if (leagueOrder !== 0) {
            return leagueOrder;
        }

        return matchByStartDateCompare(a, b);
    });

    return result;
}

function filter(matches, date) {
    let result = [];

    date = new Date(date);

    matches.forEach((m) => {
        if (new Date(m.get('startDate')) <= date) {
            result.push(m);
        }
    });

    return result;
}

function groupByLeague(matches, sports, leagues) {
    let currentGroup = {};

    const result = [];

    for (let i = 0; i < matches.length; i++) {
        const match = matches[i];
        const league = leagues.get(match.get('leagueId'));

        if (currentGroup.league !== league) {
            if (i !== 0) {
                result.push(currentGroup);
            }

            const sport = sports.get(match.get('sportId'));
            const groupMatches = [match];

            currentGroup = {
                league,
                sport,
                matches: groupMatches
            };
        } else {
            const groupMatches = [];
            groupMatches.push(match);

            currentGroup.matches = currentGroup.matches.concat(groupMatches);
        }
    }

    result.push(currentGroup);

    return result;
}

export default class Grid extends React.Component {
    static propTypes = {
        sports: React.PropTypes.instanceOf(Map).isRequired,
        leagues: React.PropTypes.instanceOf(Map).isRequired,
        matches: React.PropTypes.instanceOf(Map).isRequired,
        sortMode: React.PropTypes.number.isRequired,
        filter: React.PropTypes.number
    };

    constructor(props) {
        super(props);

        const {filter} = props;

        let dateFilter;

        if (filter === null) {
            dateFilter = null;
        } else {
            const date = new Date();

            dateFilter = new Date(date.getTime() + filter * 60 * 60 * 1000);
        }

        this.state = {
            dateFilter
        };
    }

    componentWillReceiveProps(nextProps) {
        const {filter} = nextProps;

        let dateFilter;

        if (filter === null) {
            dateFilter = null;
        } else {
            const date = new Date();

            dateFilter = new Date(date.getTime() + filter * 60 * 60 * 1000);
        }

        this.setState({
            dateFilter
        });
    }

    render() {
        const {sports, leagues, matches, sortMode} = this.props;
        const {dateFilter} = this.state;

        const matchesToShow = dateFilter === null ? matches.toArray() : filter(matches, dateFilter);

        if (matchesToShow.length === 0) {
            return false;
        }

        const sortedMatches = sortMode === SortMode.SORT_BY_TIME
            ? sortByTime(matchesToShow)
            : sortByLeague(matchesToShow, sports, leagues);

        const groups = groupByLeague(sortedMatches, sports, leagues);

        let leagueElements = [];

        for (let i = 0; i < groups.length; i++) {
            const {sport, league} = groups[i];

            const groupMatches = groups[i].matches;

            leagueElements.push(
                <League key={i} league={league} sport={sport} matches={groupMatches}/>
            );
        }

        return (
            <div>
                {leagueElements}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./js/sport-betting/components/Timetable/components/Grid.jsx